import { render, staticRenderFns } from "./TourAdminNotificationPreferences.vue?vue&type=template&id=fe9eb0f6&scoped=true"
import script from "./TourAdminNotificationPreferences.vue?vue&type=script&lang=js"
export * from "./TourAdminNotificationPreferences.vue?vue&type=script&lang=js"
import style0 from "./TourAdminNotificationPreferences.vue?vue&type=style&index=0&id=fe9eb0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9eb0f6",
  null
  
)

export default component.exports